import { CgEye } from "react-icons/cg";
import { MdEdit } from "react-icons/md";
import { titleCase } from "change-case-all";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Paper } from "../../../components";
import { HeadingEighteen, TextFourteenBlack } from "../../css components/Style";

let colors = JSON.parse(sessionStorage.getItem("siteColors"));

const Card = styled(Grid)`
  display: flex;
  gap: 20px;
`;

const OuterCard = styled(Paper)`
  display: flex;
  gap: 20px;
  margin: 8px 0;
  padding: 10px;
`;

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.primary};
  color: ${colors?.primary};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.primary};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ groups }) {
  const navigate = useNavigate();

  return (
    <Grid container spacing={0}>
      {groups?.map((group, index) => (
        <Grid size={12} key={index}>
          <OuterCard elevation={1}>
            <Grid size>
              <Card container spacing={2}>
                <Grid size={3}>
                  <TextFourteenBlack>Group Name</TextFourteenBlack>

                  <HeadingEighteen>
                    {titleCase(group.category_name)}
                  </HeadingEighteen>
                </Grid>

                <Grid size={3}>
                  <TextFourteenBlack>Group Title</TextFourteenBlack>

                  <HeadingEighteen>{group.category_title}</HeadingEighteen>
                </Grid>

                <Grid size={2}>
                  <TextFourteenBlack>Group Priority</TextFourteenBlack>

                  <HeadingEighteen>{group.priority}</HeadingEighteen>
                </Grid>
              </Card>
            </Grid>

            <Grid
              item
              alignSelf={"center"}
              display={"flex"}
              justifyContent={"flex-end"}
            >
              <Tooltip title="Edit Group">
                <Icon>
                  <MdEdit
                    style={{ height: "20px", width: "20px" }}
                    onClick={() =>
                      navigate(
                        pages.groupDetailsPage.route + group.id + "?mode=edit"
                      )
                    }
                  />
                </Icon>
              </Tooltip>
            </Grid>

            <Grid
              item
              alignSelf={"center"}
              display={"flex"}
              justifyContent={"flex-end"}
            >
              <Tooltip title="View Group">
                <Icon>
                  <CgEye
                    style={{ height: "20px", width: "20px" }}
                    onClick={() =>
                      navigate(
                        pages.groupDetailsPage.route + group.id + "?mode=view"
                      )
                    }
                  />
                </Icon>
              </Tooltip>
            </Grid>
          </OuterCard>
        </Grid>
      ))}
    </Grid>
  );
}
